import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const Item3dIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M12.31 5.96C12.12 5.85 11.88 5.85 11.68 5.96L6.95001 8.71C6.76001 8.82 6.64001 9.03 6.64001 9.25V14.75C6.64001 14.97 6.76001 15.18 6.95001 15.29L11.68 18.04C11.87 18.15 12.11 18.15 12.31 18.04L17.04 15.29C17.23 15.18 17.35 14.97 17.35 14.75V9.25C17.35 9.03 17.23 8.82 17.04 8.71L12.31 5.96ZM7.90001 14.39V10.37L11.38 12.36V16.4C11.38 16.4 11.38 16.4 11.38 16.42L7.90001 14.39ZM12 11.28L8.48001 9.27L12 7.22L15.52 9.27L12 11.28ZM16.11 14.39L12.63 16.42C12.63 16.42 12.63 16.42 12.63 16.4V12.36L16.11 10.37V14.39Z"
        fill={color}
      />
      <path
        d="M21.27 5.02L13.38 0.440002C12.53 -0.0599976 11.47 -0.0599976 10.62 0.440002L2.72999 5.02C1.88999 5.51 1.35999 6.42 1.35999 7.4V16.6C1.35999 17.58 1.87999 18.49 2.72999 18.98L10.62 23.57C11.47 24.07 12.53 24.07 13.38 23.57L21.27 18.98C22.11 18.49 22.64 17.58 22.64 16.6V7.4C22.64 6.42 22.12 5.51 21.27 5.02ZM21.14 16.6C21.14 17.04 20.9 17.46 20.52 17.68L12.63 22.27C12.24 22.49 11.76 22.49 11.37 22.27L3.47999 17.68C3.09999 17.46 2.85999 17.04 2.85999 16.6V7.4C2.85999 6.96 3.09999 6.54 3.47999 6.32L11.37 1.73C11.76 1.51 12.24 1.51 12.63 1.73L20.52 6.32C20.9 6.54 21.14 6.96 21.14 7.4V16.6Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

Item3dIcon.displayName = 'Item3dIcon';
